import axios from "axios";
import { NewsSpecsURL } from "../../Services";
import { getFromStorage, saveToStorage } from "../../../util/StorageUtil";

export async function getAllSites() {
  if (getFromStorage("sites") == null) {
    var res = await axios.get(NewsSpecsURL + "api/site/view/all");
    saveToStorage("sites", res.data, 30000000);
    return res.data;
  }
  return getFromStorage("sites");
}

export async function getAllForums() {
  if (getFromStorage("forums") == null) {
    var res = await axios.get(NewsSpecsURL + "api/forum/view/all");
    saveToStorage("forums", res.data, 3600);
    return res.data;
  }
  return getFromStorage("forums");
}
